export const version = '2.48.1';
//# sourceMappingURL=version.js.map